import { create } from 'zustand'

export type ARInfoBase = {
  schoolId: string
  tankId: string
}

export type ARInfo = ARInfoBase[]

export type ARState = { [batchId: string]: ARInfo }

type ARStore = {
  activeRelations: ARState
  setActiveRelations: (relations: ARState) => void
}

export const useActiveRelationStore = create<ARStore>((set) => ({
  activeRelations: {},
  setActiveRelations: (relations) => {
    set(() => ({ activeRelations: relations }))
  },
}))
